// @flow

// Exports
export default function asPrimaryKey (maybeValue: ?mixed): ?number {
  if (maybeValue != null) {
    if (typeof maybeValue === 'object') {
      return asPrimaryKey(maybeValue.id)
    }

    const id = Number(maybeValue)
    if (!isNaN(id) && id != null && id >= 1) {
      return id
    }
  }

  return null
}
